import commonReducers from '../../common/.config/redux/reducers'
import adminReducers from '../../admin/.config/redux/reducers'

//export redux objects
export default {
	...commonReducers,
	...adminReducers
};
